import "./HashtagPart.scss"

interface HashtagPartProps {
    hashtag: string
}

export function HashtagPart({ hashtag }: HashtagPartProps) {
    return (
        <span className="HashtagPart" data-testid="hashtag-part">
            #{hashtag}
        </span>
    )
}
